var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCareHistoryStdTestVisit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      width: 25
    },
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.262 10.381a8.539 8.539 0 0 0-5.476-2.477c-.13-2.086-1.043-3.911-2.477-5.475a8.305 8.305 0 0 0-11.864.13 8.579 8.579 0 0 0 0 11.994 8.539 8.539 0 0 0 5.475 2.478c.13 2.086 1.043 3.91 2.478 5.475a8.46 8.46 0 0 0 11.994 0 8.87 8.87 0 0 0-.13-12.125Zm-9.648-6.127a5.652 5.652 0 0 1 1.695 3.911 8.592 8.592 0 0 0-3.13 1.434L5.183 3.472c2.347-1.435 5.476-1.174 7.432.782ZM3.357 5.297l6.128 6.128c-.684.935-1.172 2-1.434 3.128-1.434-.13-2.869-.651-3.912-1.694a6.305 6.305 0 0 1-.782-7.562Zm8.735 6.91a5.951 5.951 0 0 1 7.562-.783L11.31 19.77c-1.564-2.478-1.304-5.607.782-7.562Zm8.475 8.474c-2.086 1.956-5.215 2.347-7.562.782l8.344-8.344a6.306 6.306 0 0 1-.782 7.562Z",
    fill: "#2FAEF3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCareHistoryStdTestVisit);
export default __webpack_public_path__ + "static/media/icon_care_history_std_test_visit.16c8e9d8cb18ba97ace5c052ad536e47.svg";
export { ForwardRef as ReactComponent };